import Vue from 'vue';
import {Orion} from '@tailflow/laravel-orion/lib/orion';
import ChaletEnquiryModal from '../ChaletEnquiryModal';
import {initHeaderMenu} from './header-menu';
import {injectLegacyScript} from './inject-legacy-script';
import {initIframePopup} from './popups';
import {initTestimonialSlider} from './sliders';
import legacyBundle from '../../assets/js/bundle.js?raw';
import bootstrap from '../../js/bootstrap.min.js?raw';
import bootstrapSelect from '../../js/bootstrap-select.js?raw';

if (!window.jQuery) {
    injectLegacyScript(legacyBundle);
}

if (window.jQuery) {
    if (!window.jQuery.fn.dropdown) {
        injectLegacyScript(bootstrap);
    }

    if (!window.jQuery.fn.selectpicker) {
        injectLegacyScript(bootstrapSelect);
    }
}

const config = window.config || {
    url: window.location.origin,
    site: 1,
};

Orion.init(config.url, 'sapi');
Orion.setToken('access-token-here');

function getModalProps()
{
    const placeholder = document.querySelector('chalet-enquiry-modal');

    if (!placeholder) {
        return {
            id: '',
            resort_id: '',
            site: config.site || 1,
        };
    }

    return {
        id: placeholder.getAttribute('id') || '',
        resort_id: placeholder.getAttribute('resort_id') || '',
        site: placeholder.getAttribute('site') || placeholder.getAttribute(':site') || config.site || 1,
    };
}

const modalAppOptions = {
    data: function ()
    {
        return {
            config: config,
            showing_chalet_enquiry_modal: false,
            modalProps: getModalProps(),
        };
    },
    methods: {
        show_booking_modal: function ()
        {
            this.showing_chalet_enquiry_modal = true;
        },
    },
};

const pageMount = document.getElementById('page');
const shouldMountPageApp = Boolean(pageMount && pageMount.querySelector('.home-new-header'));
let modalApp;

if (shouldMountPageApp) {
    modalApp = new Vue({
        ...modalAppOptions,
        el: pageMount,
        components: {
            'chalet-enquiry-modal': ChaletEnquiryModal,
        },
    });
} else {
    const modalMount = document.createElement('div');
    document.body.appendChild(modalMount);

    modalApp = new Vue({
        ...modalAppOptions,
        render: function (createElement)
        {
            if (!this.showing_chalet_enquiry_modal) {
                return createElement('span', {
                    style: {
                        display: 'none',
                    },
                });
            }

            return createElement(ChaletEnquiryModal, {
                props: this.modalProps,
                on: {
                    close: () => {
                        this.showing_chalet_enquiry_modal = false;
                    },
                },
            });
        },
    }).$mount(modalMount);
}

function isEnquiryTrigger(element)
{
    return element.getAttribute('data-target') === '#enquiryForm'
        || element.getAttribute('@click.prevent') === 'show_booking_modal'
        || element.getAttribute('v-on:click.prevent') === 'show_booking_modal';
}

function initEnquiryTriggers()
{
    if (shouldMountPageApp) {
        return;
    }

    Array.from(document.querySelectorAll('a, button, img')).forEach((element) => {
        if (!isEnquiryTrigger(element)) {
            return;
        }

        if (element.dataset.enquiryTriggerInitialized) {
            return;
        }

        element.dataset.enquiryTriggerInitialized = '1';

        element.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            modalApp.show_booking_modal();
        });
    });
}

function initSearchFormSelectpicker()
{
    if (!window.jQuery || !window.jQuery.fn.selectpicker) {
        return;
    }

    window.jQuery('.selectpicker').selectpicker({
        style: 'btn-default',
        size: 4,
    });
}

function initScrollToHeader()
{
    window.scrollToHeader = function () {
        if (!window.jQuery) {
            return;
        }

        const $header = window.jQuery('#chaletHeader');

        if (!$header.length) {
            return;
        }

        window.jQuery('html,body').animate({
            scrollTop: $header.offset().top - 140,
        }, 'slow');
    };
}

function initStickyHeader()
{
    if (!window.jQuery) {
        return;
    }

    const $ = window.jQuery;
    const $window = $(window);

    function updateStickyHeader()
    {
        $('header').toggleClass('sticky', $window.scrollTop() > 50);
    }

    $window.off('scroll.sbStickyHeader');
    $window.on('scroll.sbStickyHeader', updateStickyHeader);
    updateStickyHeader();
}

document.addEventListener('DOMContentLoaded', function () {
    initScrollToHeader();
    initStickyHeader();
    initIframePopup();
    initTestimonialSlider();
    initEnquiryTriggers();
    initHeaderMenu();
    initSearchFormSelectpicker();
});

export default {
    modalApp,
    initEnquiryTriggers,
    initHeaderMenu,
    initIframePopup,
    initSearchFormSelectpicker,
    initScrollToHeader,
    initStickyHeader,
    initTestimonialSlider,
};
